import TRANSLATE_EN from "./en/translations.json";
import TRANSLATE_ES from "./es/translations.json";
import TRANSLATE_DE from "./de/translations.json";

export const translations = {
  es: { translation: TRANSLATE_ES },
  en: { translation: TRANSLATE_EN },
  de: { translation: TRANSLATE_DE },
};
